var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 6.5C0 2.91015 2.91015 0 6.5 0C10.0899 0 13 2.91015 13 6.5C13 10.0899 10.0899 13 6.5 13C2.91015 13 0 10.0899 0 6.5Z",
    fill: "#FF0000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.82177 4.89437C9.74203 4.58806 9.50709 4.34685 9.20876 4.26499C8.66812 4.11621 6.49999 4.11621 6.49999 4.11621C6.49999 4.11621 4.33187 4.11621 3.79119 4.26499C3.49286 4.34685 3.25791 4.58806 3.17818 4.89437C3.03333 5.44953 3.03333 6.60788 3.03333 6.60788C3.03333 6.60788 3.03333 7.76618 3.17818 8.32138C3.25791 8.62769 3.49286 8.8689 3.79119 8.95081C4.33187 9.09954 6.49999 9.09954 6.49999 9.09954C6.49999 9.09954 8.66812 9.09954 9.20876 8.95081C9.50709 8.8689 9.74203 8.62769 9.82177 8.32138C9.96666 7.76618 9.96666 6.60788 9.96666 6.60788C9.96666 6.60788 9.96666 5.44953 9.82177 4.89437",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.84998 7.80046V5.63379L7.58331 6.71716L5.84998 7.80046Z",
    fill: "#FF0000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.d4e1b34098d162d3b1b4a61fe9b304fb.svg";
export { ForwardRef as ReactComponent };